import { ChevronRight, Lock } from 'lucide-react';
import clsx from 'clsx';
import { useState } from 'react';
import { blockedSummary, KIND_LABELS, LEGAL_BLOCK_LABEL } from '../policies/check-reasons.policy';
import type { BlockedRow as BlockedRowData } from '../policies/picker-candidates.policy';
import { BlockedChecks } from './BlockedChecks';
import { Registration } from './Registration';

/** A blocked truck, trailer or driver: greyed, no Choose, the reason in view and every failed check one click away. */
export function BlockedRow({ row }: { row: BlockedRowData }) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = `blocked-${row.key}`;
  return (
    <li className="border-b border-line px-3 py-2 last:border-b-0">
      <div className="flex items-center gap-3 opacity-70">
        <button
          type="button"
          aria-expanded={isOpen}
          aria-controls={panelId}
          aria-label={`${isOpen ? 'Hide' : 'Show'} checks for ${row.label}`}
          className="grid size-5 shrink-0 place-items-center rounded text-muted hover:text-fg"
          onClick={() => setIsOpen((open) => !open)}
        >
          <ChevronRight className={clsx('size-4 transition-transform', isOpen && 'rotate-90')} aria-hidden />
        </button>
        <span className="w-14 shrink-0 text-xs text-muted">{KIND_LABELS[row.kind]}</span>
        {row.kind === 'driver' ? <span className="text-sm text-fg">{row.label}</span> : <Registration value={row.label} linksToUnit={row.kind === 'truck'} />}
        <span className="min-w-0 flex-1 text-xs text-muted">{blockedSummary(row)}</span>
        {row.isLegalBlock && (
          <span className="flex shrink-0 items-center gap-1 rounded bg-error/10 px-1.5 py-0.5 text-xs font-medium text-error">
            <Lock className="size-3" aria-hidden />
            {LEGAL_BLOCK_LABEL}
          </span>
        )}
      </div>
      {isOpen && <BlockedChecks id={panelId} checks={row.failedChecks} />}
    </li>
  );
}
